import React from 'react';
import { FORGOTTEN_PASSWORD_REQUEST } from '@sizeid/shared/constants/routes';

import RouteLink from 'components/RouteLink';

import ForgottenPasswordLinkContainer from './styled/ForgottenPasswordLinkContainer';
import { ForgottenPasswordLinkProps } from './types';

const ForgottenPasswordLink: React.FC<ForgottenPasswordLinkProps> = ({
  advisor,
  label,
}) => (
  <ForgottenPasswordLinkContainer>
    <RouteLink
      href={{
        pathname: FORGOTTEN_PASSWORD_REQUEST.page,
        query: advisor ? { advisor } : undefined,
      }}
      passHref
    >
      <a href={FORGOTTEN_PASSWORD_REQUEST.route}>{label}</a>
    </RouteLink>
  </ForgottenPasswordLinkContainer>
);

export default ForgottenPasswordLink;
